import { useQuery } from '@tanstack/react-query';
import { useInstitutionStore } from '@/modules/auth/presentation/store/institution.store';
import { authContainer } from '@/modules/auth/di/container';
import { triContainer } from '../../di/container';

export function useStudentTri(editionId: string, email: string) {
  const { institutionName } = useInstitutionStore();
  const isAuthenticated = institutionName
    ? authContainer.repository.isAuthenticated(institutionName)
    : false;

  return useQuery({
    queryKey: ['tri', 'student-tri', institutionName, editionId, email],
    queryFn: () => triContainer.repository.getStudentTri(editionId, email),
    enabled: isAuthenticated && !!editionId && !!email,
    retry: false,
  });
}
